import type { MonthAbbreviation } from './types';

// Map of month abbreviations to Thai month names
const THAI_MONTH_NAMES: Record<MonthAbbreviation, string> = {
  JAN: 'มกราคม',
  FEB: 'กุมภาพันธ์',
  MAR: 'มีนาคม',
  APR: 'เมษายน',
  MAY: 'พฤษภาคม',
  JUN: 'มิถุนายน',
  JUL: 'กรกฎาคม',
  AUG: 'สิงหาคม',
  SEP: 'กันยายน',
  OCT: 'ตุลาคม',
  NOV: 'พฤศจิกายน',
  DEC: 'ธันวาคม',
};

export const MONTH_ORDER: MonthAbbreviation[] = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

export function getMonthOrder(monthAbbr: string) {
  return MONTH_ORDER.indexOf(monthAbbr.toUpperCase() as MonthAbbreviation);
}

function getThaiMonthName(monthAbbr: string) {
  // Convert to uppercase to handle case insensitivity
  const normalizedMonthAbbr = monthAbbr.toUpperCase() as MonthAbbreviation;

  // Return the Thai month name or the original input if not found
  return THAI_MONTH_NAMES[normalizedMonthAbbr] ?? monthAbbr;
}

export function getExamDistributionTitle(year: number, month: string) {
  const thaiMonth = getThaiMonthName(month);

  return `เดือน${thaiMonth}/${year}`;
}

/**
 * Validates if the provided string is a valid month abbreviation
 * @param monthAbbr The month abbreviation to validate (e.g., 'JAN', 'FEB')
 * @returns True if the abbreviation is valid, false otherwise
 */
export function isValidMonthAbbr(monthAbbr: string) {
  if (!monthAbbr || typeof monthAbbr !== 'string') {
    return false;
  }

  // Check if the normalized abbreviation exists in our mapping
  return MONTH_ORDER.includes(monthAbbr as MonthAbbreviation);
}
